<script setup>

import { ElPopover } from "element-plus";
import { getRoles } from "@/composable/users/getRoles.js";
import { computed } from "vue";

const roles = getRoles();
const isSuperAdmin = roles?.isSuperAdmin?.value;
const isAccountManager = roles?.isAccountManager?.value;
const isSpecificManager = roles?.isSpecificManager?.value;
const isMultiStoreManager = roles?.isMultiStoreManager?.value;

const hasRequiredRoles = computed(() => {
  return isAccountManager || isSuperAdmin || isSpecificManager || isMultiStoreManager;
});

const baseRoutes = [
  {
    name: "Assignment History",
    to: "/reports?tab=assignment-history",
    urlType: "lms",
  },
  {
    name: "User Progress",
    to: "/reports?tab=course-overview",
    urlType: "lms",
  },
  {
    name: "Leaderboards",
    to: "/leaderboard",
    urlType: "lms",
  }
];

const completedContentRoute = {
  name: "Completed Content Summary",
  to: "/reports?tab=completed-content-summary",
  urlType: "lms",
};

const getOrderedRoutes = () => {
  if (hasRequiredRoles.value) {
    // Filter out Leaderboards from baseRoutes and add it at the end
    const routesWithoutLeaderboards = baseRoutes.filter(route => route.name !== "Leaderboards");
    const leaderboardsRoute = baseRoutes.find(route => route.name === "Leaderboards");
    return [...routesWithoutLeaderboards, completedContentRoute, leaderboardsRoute];
  }
  // For users without required roles, Leaderboards is already at the bottom of baseRoutes
  return baseRoutes;
};

const routes = computed(() => {
  return getOrderedRoutes();
});

if (
  roles.isSuperAdmin.value ||
  roles.isAccountManager.value ||
  roles.isSpecificManager.value
) {
  routes.value.push({
    name: "Call Simulation Performance",
    to: "/call-simulation-performance",
    urlType: "lms",
  });
}

</script>
<template>
  <div v-bind="$attrs">
    <el-popover :width="230" popper-style="padding: 5px !important;z-index: 3000 !important">
      <template #reference>
        <a
          class="text-untitled-gray-300 border-transparent hover:border-untitled-gray-300 border-b-2 hover:text-untitled-gray-100 px-1 pt-1 text-sm w-full h-full flex justify-center items-center font-medium"
        >
          Reports
        </a>
      </template>
      <template #default>
        <div class="w-full flex flex-col justify-start items-start">
          <div
            class="w-full"
            v-for="(route, index) in routes "
            :key="index"
          >
            <router-link
              class="w-full px-2 py-2 hover:bg-gray-200 text-sm text-untitled-gray-700 flex justify-start items-start"
              :to="route.to"
            >
              {{ route.name }}
            </router-link>
          </div>
        </div>
      </template>
    </el-popover>
  </div>
</template>
<style lang="scss" scoped></style>
